import React, { useState } from "react"
import { Decorator, Input, Button } from "components"
import { navigate } from "gatsby"
import {isValidZipCode} from "utils"

const INVALID_ZIP_CODE = "Please enter a valid zip code.";
const ZIP_CODE_REQUIRED = "Zip Code is required.";

/**
 * Career DropDown component 
 * Returns  Job Search fields 
 * @param  {array} {decorators
 * @param  {string} heading}
 */
function CareerDropdown({ decorators, heading}) {
  
  const [jobZipCode, setZipCode] = useState("")
  const [jobKeyWord, setKeyWord] = useState("")
  const [errorMessage, setErrorMessage] = useState("")
  
  /**
   * function picks job keyword and zipcode inputs 
   * and navigates to job-board page to search aPI for jobs.
   * Sets error message when user makes a search with both fields empty.
   * @param  {string} jobKeyWord
   * @param  {string} jobZipCode
   */
  const searchJobs = (jobKeyWord,jobZipCode)=>{
    if(jobKeyWord || jobZipCode){
      if(isValidZipCode(jobZipCode)){
        if (typeof window !== "undefined") {
          navigate(`/careers/job-board?keyword=${jobKeyWord}&zipcode=${jobZipCode}`)
        }
       }else{
        setErrorMessage(INVALID_ZIP_CODE)
       }   
    }else {
       setErrorMessage(ZIP_CODE_REQUIRED);
    }
  }

  /**
   * function picks job keyword and zipcode inputs 
   * and navigates to job-board page to search aPI for jobs.
   * Sets error message when user makes a search with both fields empty.
   */
  const viewAllJobs = ()=>{
    navigate(`/careers/job-board?all=true`)
  }

  /**
   * Returns error message to be displayed
   * Called when user makes search with both keyword and zipcode are empty fields
   * @param  {string} errorMessage
   */
  const showErrorMessage =(errorMessage) => {
    return (
      <div className="space-y-2">
        <div className="flex justify-center gap-6 mb-16">
          <div className="flex justify-center">
             <p className="nav-primary text-red">{errorMessage}</p>
          </div>
        </div>
      </div>
    )
  }

  /*
   component render return block
  */

  return (
    <section
      data-slice="CareerDropdown"
      className="relative py-6 space-y-6 md:space-y-12 wrapper md:pt-20 md:pb-24"
    >
      {decorators && decorators[0] && (
        <Decorator
          className="relative top-0 left-0 -translate-x-4 select-none lg:absolute lg:-translate-x-1/2"
          asset={decorators && decorators[0].asset}
          size="small"
        />
      )}
      {decorators && decorators[1] && (
        <Decorator
          className="absolute bottom-0 left-0 hidden -translate-x-1/2 select-none md:block translate-y-1/4"
          asset={decorators && decorators[1].asset}
          size="large"
        />
      )}
      {decorators && decorators[2] && (
        <Decorator
          className="absolute top-0 right-0 hidden translate-x-1/2 select-none md:block"
          asset={decorators && decorators[2].asset}
          size="large"
        />
      )}
      <div className="default-grid gap-y-8">
        {heading && (
          <h2 className="text-center h1 text-darkPurple md:col-start-2 md:col-span-10 col-span-full">
            {heading}
          </h2>
        )}
      </div>

      <div className="default-grid">
        <div className="px-4 py-5 border-2 md:px-10 md:py-8 border-violet md:col-start-4 md:col-span-6 col-span-full bg-lightBlue">
          <div className="space-y-8">
            <h2 className="text-center lead-copy">Find your career</h2>
            <div className="flex flex-col md:flex-row md:items-center gap-6">
              <div className="flex-1">
                <Input
                  id="keyWord"
                  placeholder="Keywords"
                  value={jobKeyWord}
                  onChange={e => {
                    setKeyWord(e.target.value)
                  }}
                />
              </div>
              <div className="flex-1">
                <Input
                  id="zipCode"
                  placeholder="Zip Code (Required)"
                  value={jobZipCode}
                  onChange={e => {
                    setZipCode(e.target.value)
                  }}
                />
              </div>
            </div>
            <div className="flex gap-x-3 justify-center flex-col space-y-5 sm:flex-row sm:space-y-0">
                <Button
                    label="Search Jobs"
                    type="submit"
                    appearance="primary"
                    onClick={()=>{ searchJobs(jobKeyWord,jobZipCode)}}
                    size="job-board"
                />
                <Button
                  label="View All Jobs"
                  type="submit"
                  appearance="secondary"
                  onClick={()=>{ viewAllJobs()}}
                  size="job-board"
                />
            </div>
          </div>
        </div>
      </div>
      <div>{errorMessage ? showErrorMessage(errorMessage) : null}</div>
    </section>
  )
}

export default CareerDropdown
